import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { setProvider } from './actions';

const providerSelector = (state) => state.provider;

export const useProvider = {
  state: () => {
    const provider = useSelect(providerSelector);
    return { provider };
  },
  actions: () => {
    return {
      setProvider: useAction(setProvider),
    };
  },
};
